import React from 'react';
import fetch from '../../../services/fetch'
import utils from './../../../utils';
import {Modal} from 'antd';
const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const querySearch = () => {
    return fetch.post('template/tree',{})
    .then(response => {
        return response.payload.data
    })
    .then(result => {
        const tree = utils.tree(result);
        const data =  transform(tree);
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

const querySearchById = (id) => {
    return fetch.post('template/tree/'+id,{})
    .then(response => {
        return response.payload.data
    })
    .then(result => {
        const tree = utils.tree(result);
        const data =  transform(tree);
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

const insert = (data) => {
    return fetch.post('template/insert', data)
    .then(response => {
        return response
    });
}

const get = (id) => {
    return fetch.get('template/get/'+id)
    .then(response => {
        return response.payload.data
    })
}

const remove = (id) => {
    return fetch.post('template/delete/'+id)
}

const update = ( id , data ) => {
    return fetch.post('template/update/'+id , data)
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('template/file/delete', ids);
}

export default {
    querySearch ,
    querySearchById,
    insert,
    get ,
    delete : remove ,
    update,
    download : `${fetch.base}template/file/download/`,
    upload: `${fetch.base}template/file`,
    deleteFile,
}